// extracted by mini-css-extract-plugin
export default {"projectsSectionContainer":"styles_projectsSectionContainer__KjhA9","projectsSectionTitle":"styles_projectsSectionTitle__E9+b1"};